
// import React from "react";
// import "@/App.css";
// import { LanguageProvider } from "./context/LanguageContext";
// import { Toaster } from "./components/ui/sonner";
// import Header from "./components/Header";
// import HeroSection from "./components/HeroSection";
// import ChallengeSection from "./components/ChallengeSection";
// import ProgrammeSection from "./components/ProgrammeSection";
// import ServicesSection from "./components/ServicesSection";
// import FacilitiesSection from "./components/FacilitiesSection";
// import DoctorsSection from "./components/DoctorsSection";
// import ProceduresSection from "./components/ProceduresSection";
// import ClinicsSection from "./components/ClinicsSection";
// import ContactSection from "./components/ContactSection";
// import Footer from "./components/Footer";
// import WhatsAppButton from "./components/WhatsAppButton";
// import Gallery from "./components/Gallery";
// import Esg from "./components/ESG/LapsleeveGastrectomy";

// import Endoscopic from "./components/ESG/Endoscopic";
// import { BrowserRouter } from "react-router-dom";

// const Layout = () => {
//   return (
//     <div>
//        <LanguageProvider>
//       <BrowserRouter>
//       <div className="App" data-testid="app-container">
//         <Toaster position="top-center" richColors />
//         <Header />
//         <main>
//           <Esg></Esg> 
//           <HeroSection />
//           <ChallengeSection />
//           <ProgrammeSection />
//           <ServicesSection />
//           <FacilitiesSection />
//           <DoctorsSection />
//            <Gallery/>
//           <ProceduresSection />
//           <ClinicsSection />
//           <ContactSection />
         
//         </main>
//         <Footer />
//         <WhatsAppButton />
//       </div>
//       </BrowserRouter>
//     </LanguageProvider>
//     </div>
//   )
// }

// export default Layout















import React from 'react'
import { LanguageProvider } from './context/LanguageContext';
import { BrowserRouter,Route,Routes } from 'react-router-dom';
 import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ChallengeSection from "./components/ChallengeSection";
import ProgrammeSection from "./components/ProgrammeSection";
import ServicesSection from "./components/ServicesSection";
import FacilitiesSection from "./components/FacilitiesSection";
import DoctorsSection from "./components/DoctorsSection";
import ProceduresSection from "./components/ProceduresSection";
import ClinicsSection from "./components/ClinicsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Gallery from "./components/Gallery";
import Esg from "./components/ESG/LapsleeveGastrectomy";

import { Toaster } from "./components/ui/sonner";

import Endoscopic from "./components/ESG/Endoscopic";
import GastricBalloon from './components/ESG/GastricBalloon';
import GastricBypass from './components/ESG/GastricBypass';
import LapsleeveGastrectomy from './components/ESG/LapsleeveGastrectomy';
import MiniGastricBypass from './components/ESG/MiniGastricBypass';

const Layout = () => {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App" data-testid="app-container">
          <Toaster position="top-center" richColors />
          <Header />

          <main>
            <Routes>
              {/* Home page */}
              <Route
                path="/"
                element={
                  <>
                    <HeroSection />
                    <ChallengeSection />
                    <ProgrammeSection />
                    <ServicesSection />
                    <FacilitiesSection />
                    <DoctorsSection />
                    <Gallery />
                    <ProceduresSection />
                    <ClinicsSection />
                    <ContactSection />
                  </>
                }
              />

              {/* Endoscopic / ESG page */}
              <Route path="/esg" element={<Esg />} />

              {/* Optional: Endoscopic component */}
 
 <Route path="/programme" element={<ProgrammeSection />} />
  <Route path="/services" element={ <ServicesSection />} />
<Route path="/facilities" element={   <FacilitiesSection />} />
 <Route path="/expert" element={   <DoctorsSection />} />  
 <Route path="/procedures" element={   <ProceduresSection />} />

              <Route path="/endoscopic" element={<Endoscopic />} />
              <Route path='/gastric-balloon' element={<GastricBalloon/>}/>
               <Route path='/gastric-bypass' element={<GastricBypass/>}/>
               <Route path='/lapsleeve-gastrectomy' element={<LapsleeveGastrectomy/>}/> 
               <Route path='/miniGastricBypass'  element={<MiniGastricBypass/>}/>
              
                <Route path="/contact" element={ <ContactSection/>} />
            </Routes>
          </main>

          <Footer />
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default Layout